// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Wp-z","badgeLink":"Xp-z","category":"Yp-z"};